import { useState } from 'react';

import { MatchCard } from '../components/MatchCard';
import { Card } from '../components/ui';
import { useMatches } from '../hooks/useMatches';

const FILTERS = [
  { label: 'All', value: undefined },
  { label: 'Pending', value: 'pending' },
  { label: 'Confirmed', value: 'confirmed' },
  { label: 'Disputed', value: 'disputed' },
] as const;

export function MatchesPage() {
  const [status, setStatus] = useState<string | undefined>(undefined);
  const matches = useMatches(status ? { status } : {});

  return (
    <>
      <h1 className="mb-4 text-2xl font-bold tracking-tight">Match history</h1>

      <div role="group" aria-label="Filter by status" className="mb-4 flex flex-wrap gap-2">
        {FILTERS.map((filter) => (
          <button
            key={filter.label}
            type="button"
            aria-pressed={status === filter.value}
            onClick={() => setStatus(filter.value)}
            className={`rounded-full px-3 py-1.5 text-sm font-medium transition ${
              status === filter.value
                ? 'bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900'
                : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300'
            }`}
          >
            {filter.label}
          </button>
        ))}
      </div>

      {matches.isPending ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : (matches.data?.matches.length ?? 0) === 0 ? (
        <Card>
          <p className="text-sm text-slate-500 dark:text-slate-400">No matches yet.</p>
        </Card>
      ) : (
        <div className="space-y-3">
          {matches.data?.matches.map((match) => <MatchCard key={match.id} match={match} />)}
        </div>
      )}
    </>
  );
}
